module.exports = __webpack_public_path__ + "media/images/banner/tjt/pc/travel202309_04_770_280_ko-c4cd1b8ec9e7b4474f6bbf0364e171dd.jpg";